import React from "react";
import { object, string } from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";
import { LazyCollection } from "@quintype/components";
import DfpAd from "../dfp-ad";

import { getCollectionTemplate } from "../get-collection-template";

import { useAutoRefresh } from "../utils/react-utils";

import "./home.m.css";

const HomePageBase = ({ pageType, data, customAds }) => {
  useAutoRefresh(pageType);

  return (
    <>
      {pageType === "home-page" && customAds.takeover && (
        <div className="adbox-container">
          <DfpAd adtype="takeover1x1" />
        </div>
      )}
      <div styleName="home-wrapper">
        <div styleName="collection-container">
          {data.collection && (
            <LazyCollection
              liveBlogStory={data.liveBlogStory}
              collection={data.collection}
              collectionTemplates={getCollectionTemplate}
              lazyAfter={1}
              mostCommentedStories={data.mostCommentedStories}
            />
          )}
        </div>
      </div>
    </>
  );
};

HomePageBase.propTypes = {
  data: object,
  pageType: string,
  customAds: object,
};

const mapStateToProps = (state) => ({
  pageType: get(state, ["qt", "pageType"], ""),
  customAds: get(state, ["qt", "config", "publisher-attributes", "customAds"], {}),
});

export const HomePage = connect(mapStateToProps)(HomePageBase);
